import { render, staticRenderFns } from "./VPageHeader.vue?vue&type=template&id=4d814d07&"
import script from "./VPageHeader.vue?vue&type=script&lang=ts&"
export * from "./VPageHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VPageHeader.vue?vue&type=style&index=0&id=4d814d07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports